import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.testimonials__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: true,
          gap: '73px',
          perPage: 2,
          paginationKeyboard: true,
          drag: true,
          pagination: false,
          start: 1,
          breakpoints: {
            768: {
              gap: '20px',
              perPage: 1,
            },
          },
        } );
        slider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'testimonials', COMPONENT );
} )( app );
